module.exports = __webpack_public_path__ + "static/media/VISA.fc0d752f.svg";